module.exports = __webpack_public_path__ + "img/Postmodernisme_Tida_og_samfunnsforhold7.b3bed750.jpg";